export function visitReadinessLabel(status: unknown, readinessStatus: unknown): string {
  if (String(status || '').toUpperCase() !== 'COMPLETED') return '—';
  const label = String(readinessStatus || '').trim();
  return label || 'PENDING';
}
